import typeCheck from 'common/util/typeCheck';
import {
  SR_API_ACTION_GET_APARTMENT_LINKS,
} from 'api/actionTypes';

export default async function getApartmentLinksAction({ state, apiClient }, { apartmentId }) {
  typeCheck('apartmentId::PositiveNumber', apartmentId);
  const statePath = ['apartmentLinksByApartmentId', apartmentId];
  if (state.exists(statePath)) {
    return state.get(statePath);
  }

  await apiClient.postWithState({
    action: SR_API_ACTION_GET_APARTMENT_LINKS,
    state: state,
    queryId: `${apartmentId}`,
    payload: {
      apartmentId,
    },
    onSuccess(apartmentLinks) {
      state.set(statePath, apartmentLinks);
    },
  });
}
